module.exports = __webpack_public_path__ + "img/pl.89250479.svg";